import { render } from "./AuthCard.vue?vue&type=template&id=24157fd8"
import script from "./AuthCard.vue?vue&type=script&lang=js"
export * from "./AuthCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__